import * as questionnaire from './questionnaire';
import * as base from './base';

export default {
  ...base,
  questionnaire,
};
